import { Collapse as CollapseA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { Icon } from '../icons';

import styles from './collapse.module.css';

type P = ComponentProps<typeof CollapseA>;

const { Panel } = CollapseA;

const Collapse = ({ className, ...rest }: P) => (
  <CollapseA
    className={cn(className, styles.collapse)}
    expandIcon={({ isActive }) => <Icon icon="down-line" rotate={isActive ? 0 : -90} />}
    {...rest}
  />
);

Collapse.Panel = Panel;

export default Collapse;
